import Button from '@/shared/components/rebranded/Button/Button';
import styled from 'styled-components';

import { RawHtmlFromTrustedSource } from '../../../../../shared/components/RawHtmlFromTrustedSource';

export const Wrapper = styled(RawHtmlFromTrustedSource)`
  & ul {
    list-style-position: inside;
  }
`;

export const AlertButton = styled(Button)`
  margin-top: 8px;
  padding-left: 0;
`;
